import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=ed9cd0b4&"
import script from "./TaskProgress.vue?vue&type=script&lang=js&"
export * from "./TaskProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports